export default function findAncestryLines(id, tree) {
  // Thanks Stan The Man 🧐
  const connections = []
  const findAtn = (atn) => {
    const isMale = atn % 2 === 0
    let nextAtn
    if (isMale) {
      nextAtn = atn / 2
    } else {
      nextAtn = (atn - 1) / 2
    }
    if (atn > 0) {
      connections.unshift(tree.find((element) => element.atn === atn))
      findAtn(nextAtn)
    }
  }

  // Same fix as below. ATN values need to be converted to numbers first
  tree.forEach((person) => {
    if (!Number.isInteger(person.atn)) {
      person.atn = parseInt(person.atn, 10)
    }
  })

  const person = tree.find((element) => element.personId === id)
  if (person) {
    // Some atn values are never numbers, such as the spouse 1-S, so filter those out.
    if (!Number.isInteger(person.atn)) {
      person.atn = parseInt(person.atn, 10)
    }
    findAtn(person.atn)
  }
  return connections
}
